<template>
  <div
    class="container_"
    @click="gotPlaylist()"
  >
    <img
      :src="placeholder_image"
      :data-src="getImageSrc()"
      alt="item"
    />
    <div class="item-counts">
      <span class="item-counts__lists">
        {{ item?.item_count }}
      </span>
      <i class="fas fa-list"></i>
    </div>
    <div class="item__details">
      <span class="dot"></span>
      <h3 class="title">{{ item.title }}</h3>
    </div>

    <i class="fas fa-play player"></i>
  </div>
</template>

<script>
export default {
  name: 'top_playlist',
  props: [
    'item',
    'default_image',
    'episode_portrait_path',
    'episode_landscape_path',
    'item_portrait_path',
    'item_landscape_path',
    'artist_path',
    'placeholder_image',
  ],
 
  methods: {
    getImageSrc() {
      if (this.item.image?.landscape) {
        return this.item.image?.landscape == null
          ? this.default_image
          : this.item_landscape_path + this.item.image?.landscape;
      } else {
        return this.default_image;
      }
    },

    gotPlaylist() {
      var url = '';
      url = `/watch-video/${this.slugOrId()}?type=manual_playlist`;
      window.location.href = url;
    },
    slugOrId() {
      if (this.item.slug) {
        return this.item.slug;
      } else {
        return this.item.id;
      }
    },
  },
};
</script>

<style scoped>
.container_ {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  flex-direction: column;
  margin: 0 auto;
  padding: 0;
  width: 100%;
  max-width: 100%;
  height: 200px;
  position: relative;
  border-radius: 5px;

  &:hover {
    cursor: pointer;
  }

  &:hover img {
    transform: scale(1.1);
    transition: transform 0.5s;
  }

  &::after{
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: linear-gradient(0deg, rgb(0 0 0) 0%, rgba(0, 0, 0, 0) 100%);
    border-radius: 5px;
    height: 100%;
    z-index: 1;
  }

  i.player {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 2rem;
    color: white;
    z-index: 2;
    visibility: hidden;
  }

  &:hover i.player {
    visibility: visible;
  }
}

.container_ img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.item-counts {
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 5px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 70px;
  height: 100%;
  z-index: 2;
}
.item-counts__lists {
  font-size: 1.5rem;
}

.item-counts i {
  font-size: 1.5rem;
  margin-top: 20px;
}
.item__details {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  margin: 0;
  padding: 0;
  width: 100%;
  max-width: 100%;
  position: absolute;
  bottom: 20px;
  left: 0;
}
.dot {
  width: 8px;
  height: 8px;
  background: red;
  border-radius: 50%;
  margin-right: 10px;
  display: none;
}
.title {
  font-size: 0.8rem;
  font-weight: 900;
  font-family: sans-serif;
  white-space: wrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  width: 100%;
  display: inline-block;
  z-index: 2;
  padding: 0px 10px;
}
</style>
